import React, { Component } from 'react'
import { Marker } from 'react-google-maps';
import { connect } from "react-redux"
import {pickPos, dropPos} from "../../actions"
import pickpin  from "../../assets/images/pickpin.png"
import droppin  from "../../assets/images/droppin.png"

export const pinIcons = {P: pickpin, D: droppin};

class BMarker extends Component {

    updatePos(pos){
        let {type, pickPos, dropPos} = this.props;
        if(type === "P"){
            pickPos(pos, type);
        } else{
            dropPos(pos, type);
        }
    }

    render() {
        let type = this.props.type;
        return (
            <CustomMarker
                position={this.props[type]}
                type={type}
                draggable
                onDragEnd={(e) => this.updatePos({lat: e.latLng.lat(), lng: e.latLng.lng()})}
            />
        )
    }
}

export const CustomMarker = ({position, type = "P", ...restProps}) => (
    <Marker
        position={position}
        label={type}
        {...restProps}
    />
)

const mapStateToProps = ({bookingLoc}) => ({
    P: bookingLoc.pickup,
    D: bookingLoc.drop
})

const mapDispatchToProps = {pickPos, dropPos};

const BookMarker = connect(mapStateToProps, mapDispatchToProps)(BMarker)

export default BookMarker
